<div class="dashboard">
  <div class="dashboard-header">
    <div class="dashboard-title-row">
      <h1 class="dashboard-title">Dashboard</h1>
      <span class="dashboard-live-pill" *ngIf="live">
        <span class="dashboard-live-dot"></span>LIVE
      </span>
      <div class="modern-theme-toggle">
        <span class="modern-theme-icon" aria-hidden="true">☀</span>
        <label class="modern-theme-switch">
          <input type="checkbox" [checked]="useDarkMode" (change)="toggleDarkMode()"
            aria-label="Toggle dark mode" />
          <span class="modern-theme-track">
            <span class="modern-theme-thumb"></span>
          </span>
        </label>
        <span class="modern-theme-icon" aria-hidden="true">☾</span>
      </div>
    </div>
    <p class="dashboard-subtitle">Entry summary for venues scanning now</p>
    <button type="button" class="dashboard-historical-link" (click)="openHistorical()">
      Get historical data
    </button>
  </div>

  <app-historical-data-modal
    [open]="historicalOpen"
    (closed)="closeHistorical()"
  ></app-historical-data-modal>

  <ng-container *ngIf="loading">
    <div class="dashboard-status">
      <tm1-progress-ring value="" min="0" max="1" size="regular"></tm1-progress-ring>
      <span>Loading venue summaries…</span>
    </div>
  </ng-container>

  <ng-container *ngIf="loadError">
    <div class="dashboard-status">
      <span>We couldn't load the venue summaries. Please try again shortly.</span>
    </div>
  </ng-container>

  <ng-container *ngIf="isEmpty">
    <div class="dashboard-status">
      <span>No venues are scanning right now.</span>
    </div>
  </ng-container>

  <div class="dashboard-grid" *ngIf="!loading && !loadError && cards.length">
    <button
      type="button"
      class="dashboard-card"
      *ngFor="let card of cards"
      (click)="openVenue(card)"
      [attr.aria-label]="'Open report for ' + card.name"
    >
      <div class="dashboard-card-label">
        <span>Entries</span>
        <span class="dashboard-card-date">{{ formatCardDate(card) }}</span>
      </div>
      <div class="dashboard-card-value">
        <app-rolling-counter [value]="card.entries"></app-rolling-counter>
      </div>
      <div class="dashboard-card-rate">
        <span class="rate-chip">
          <app-rolling-counter [value]="card.scanRate"></app-rolling-counter>
          <span class="rate-unit">scans / min</span>
        </span>
      </div>
      <div class="dashboard-card-venue">{{ card.name }}</div>
    </button>
  </div>

  <ng-container *ngIf="!loading && !loadError && cards.length">
    <h2 class="dashboard-section-title">Venue Totals</h2>
    <div class="extended-summary-table-wrapper">
      <table class="extended-summary-table">
        <thead>
          <tr>
            <th class="sortable" (click)="toggleSort('name')">Venue Name <span class="sort-indicator">{{ sortIndicator('name') }}</span></th>
            <th class="sortable" (click)="toggleSort('entries')">Entries <span class="sort-indicator">{{ sortIndicator('entries') }}</span></th>
            <th class="sortable" (click)="toggleSort('exits')">Exits <span class="sort-indicator">{{ sortIndicator('exits') }}</span></th>
            <th class="sortable" (click)="toggleSort('internal')">Internal <span class="sort-indicator">{{ sortIndicator('internal') }}</span></th>
            <th class="sortable" (click)="toggleSort('reentries')">Reentries <span class="sort-indicator">{{ sortIndicator('reentries') }}</span></th>
            <th class="sortable" (click)="toggleSort('inVenue')">Inside <span class="sort-indicator">{{ sortIndicator('inVenue') }}</span></th>
            <ng-container *ngIf="rejectColumns.length">
              <th class="reject-col reject-pct-col sortable" (click)="toggleSort('__rejectPct')">Reject % <span class="sort-indicator">{{ sortIndicator('__rejectPct') }}</span></th>
              <th class="reject-col reject-total-col sortable"
                [class.expanded]="rejectsExpanded"
                title="Click to {{ rejectsExpanded ? 'hide' : 'show' }} reject breakdown">
                <span class="reject-total-label" (click)="toggleSort('__rejectTotal'); $event.stopPropagation()">
                  Rejects
                  <span class="sort-indicator">{{ sortIndicator('__rejectTotal') }}</span>
                </span>
                <span class="reject-toggle-arrow" (click)="toggleRejectsExpanded(); $event.stopPropagation()">
                  {{ rejectsExpanded ? '▾' : '▸' }}
                </span>
              </th>
              <ng-container *ngIf="rejectsExpanded">
                <th class="reject-col sortable" *ngFor="let code of rejectColumns"
                  (click)="toggleSort('__reject:' + code)">
                  {{ formatErrorCode(code) }} <span class="sort-indicator">{{ sortIndicator('__reject:' + code) }}</span>
                </th>
              </ng-container>
            </ng-container>
          </tr>
        </thead>
        <tbody>
          <tr class="totals-row">
            <td class="primary-cell">All Venues Total</td>
            <td>{{ totalsRow.entries }}</td>
            <td>{{ totalsRow.exits }}</td>
            <td>{{ totalsRow.internal }}</td>
            <td>{{ totalsRow.reentries }}</td>
            <td>{{ totalsRow.inVenue }}</td>
            <ng-container *ngIf="rejectColumns.length">
              <td class="reject-col reject-pct-col" [class.is-zero]="!rejectTotal(totalsRow.rejects)">
                {{ rejectPercent(totalsRow) | number: '1.0-2' }}%
              </td>
              <td class="reject-col reject-total-col" [class.is-zero]="!rejectTotal(totalsRow.rejects)">
                {{ rejectTotal(totalsRow.rejects) }}
              </td>
              <ng-container *ngIf="rejectsExpanded">
                <td class="reject-col" *ngFor="let code of rejectColumns"
                  [class.is-zero]="!rejectCount(totalsRow.rejects, code)">
                  {{ rejectCount(totalsRow.rejects, code) }}
                </td>
              </ng-container>
            </ng-container>
          </tr>
          <tr *ngFor="let row of sortedRows">
            <td class="primary-cell">
              <a href="javascript:void(0)" (click)="openVenue(row)">{{ row.name }}</a>
            </td>
            <td>{{ row.entries }}</td>
            <td>{{ row.exits }}</td>
            <td>{{ row.internal }}</td>
            <td>{{ row.reentries }}</td>
            <td>{{ row.inVenue }}</td>
            <ng-container *ngIf="rejectColumns.length">
              <td class="reject-col reject-pct-col" [class.is-zero]="!rejectTotal(row.rejects)">
                {{ rejectPercent(row) | number: '1.0-2' }}%
              </td>
              <td class="reject-col reject-total-col" [class.is-zero]="!rejectTotal(row.rejects)">
                {{ rejectTotal(row.rejects) }}
              </td>
              <ng-container *ngIf="rejectsExpanded">
                <td class="reject-col" *ngFor="let code of rejectColumns"
                  [class.is-zero]="!rejectCount(row.rejects, code)">
                  {{ rejectCount(row.rejects, code) }}
                </td>
              </ng-container>
            </ng-container>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>
</div>
